<template>
    <div class="flex justify-center items-center px-[5px] py-1 rounded-full  "
        :class="disabled ? 'shadow-none bg-[#E5E5E5]' : 'shadow-[0px_0px_10px_0px_#00000026] bg-[#fff]'">
        <span type="button" @click="!disabled && decrementCount()" :class="[
            'mobile:!bg-transparent tablet:text-xl mobile:!h-full mobile:!w-auto tablet:h-8 tablet:w-8 rounded-full mobile:leading-[1.5] tablet:leading-[1.6] text-center hover:text-white',
            disabled ? 'cursor-not-allowed pointer-events-none text-white' : (quantity > 1 ? 'text-customBlue-100 hover:bg-customBlue-100' : 'text-rose-400 hover:bg-rose-400')
        ]">
            <div v-if="quantity > 1">
                <div class="transform lg:hover:scale-[1.15] active:scale-[0.98] duration-300 transition-all group !h-[28px] !w-[28px] flex items-center justify-center"
                    v-if="isTabletOrAbove || disabled">
                    <img src="../../assets/images/minus-icon.svg" alt="Cart Icon"
                        class="!h-[20px] !w-[20px] group-hover:hidden">
                    <img src="../../assets/images/minus-icon-with-bg.svg" alt="Cart Icon"
                        class="!h-full !w-full hidden group-hover:!block">
                </div>
                <img src="../../assets/images/minus-icon-with-bg.svg" alt="Cart Icon" class="smallMobile:!h-[26px] smallMobile:!w-[26px] !h-8 !w-8" v-else>
            </div>

            <div class="transform lg:hover:scale-[1.15] active:scale-[0.98] duration-300 transition-all group flex items-center justify-center h-full p-1 rounded-full hover:bg-[#FE5000]"
                v-else-if="isTabletOrAbove || disabled">
                <img src="../../assets/images/trash-icon-updated.png" alt="Cart Icon" :class="['!w-[20px] !h-[20px] group-hover:hidden smallMobile:!w-[18px] smallMobile:!h-[18px]',
                    disabled ? 'cursor-not-allowed pointer-events-none hidden' : '']">
                <img src="../../assets/images/trash-icon-white-updated.png" alt="Cart Icon" :class="['!w-[20px] !h-[20px] hidden group-hover:!block smallMobile:!w-[18px] smallMobile:!h-[18px]',
                    disabled ? 'cursor-not-allowed pointer-events-none !block' : ''
                ]">
            </div>
            <div class="transform lg:hover:scale-[1.15] active:scale-[0.98] duration-300 transition-all rounded-full flex items-center justify-center bg-[#FE5000] smallMobile:!h-[26px] smallMobile:!w-[26px] !h-8 !w-8" v-else>
                <img src="../../assets/images/trash-icon-white-updated.png" alt="Cart Icon" class="!w-[20px] !h-[20px]">
            </div>
        </span>
        <input type="text" name="count" :value="quantity" readonly :class="[
            'w-[40px] h-[30px] mobile:px-2 mobile:py-1 tablet:p-2 text-center text-xl  focus:outline-0 bg-transparent',
            disabled ? 'text-white cursor-not-allowed pointer-events-none' : '']" />
        <span type="button" @click="!disabled && incrementCount()" :class="[
            'transform lg:hover:scale-[1.15] active:scale-[0.98] duration-300 transition-all mobile:!bg-transparent tablet:text-xl tablet:h-full rounded-full mobile:leading-[1.4] tablet:leading-[1.6] text-center text-customBlue-100 hover:bg-customBlue-100 hover:text-white',
            disabled ? 'text-white cursor-not-allowed pointer-events-none' : ''
        ]">

            <div class="group smallMobile:!h-[28px] smallMobile:!w-[28px] !h-[28px] !w-[28px] flex items-center justify-center" v-if="isTabletOrAbove || disabled">
                <!-- <img v-if="disabled" src="../../assets/images/disable-plus.svg" alt="Cart Icon"
                    class="!max-h-[20px] !max-w-[20px] !min-h-[20px] !min-w-[20px] group-hover:hidden"> -->
                    <img v-if="disabled" src="../../assets/images/plus-white.svg" alt="Cart Icon"
                        class="!max-h-[20px] !max-w-[20px] !min-h-[20px] !min-w-[20px] group-hover:hidden">
                <div v-else>
                    <img src="../../assets/images/plus-icon.svg" alt="Cart Icon"
                        class="!max-h-[20px] !max-w-[20px] !min-h-[20px] !min-w-[20px] group-hover:hidden">
                    <img src="../../assets/images/plus-icon-with-bg.svg" alt="Cart Icon"
                        class="!h-full !w-full hidden group-hover:!block">
                </div>
            </div>
            <img src="../../assets/images/plus-icon-with-bg.svg" alt="Cart Icon" class="smallMobile:!h-[26px] smallMobile:!w-[26px] !h-8 !w-8" v-else>
        </span>
    </div>
</template>

<script>
export default {
    props: ["quantity", "product", "disabled"],
    data() {
        return {
            isTabletOrAbove: window.innerWidth >= 1024,
        };
    },
    mounted() {
        window.addEventListener('resize', this.checkScreenSize);
    },
    beforeUnmounted() {
        window.removeEventListener('resize', this.checkScreenSize);
    },
    methods: {
        incrementCount() {
            this.$emit('update-counter', "increment", this.product)
            // this.count++;
        },
        decrementCount() {
            this.$emit('update-counter', "decrement", this.product)
            // if (this.count > 1) {
            //     this.count--
            // } else {
            //     this.$emit('hide-counter')
            // }
        },
        checkScreenSize() {
            this.isTabletOrAbove = window.innerWidth >= 992;
        },
    },
};
</script>
